import { rj, useRj } from 'react-rocketjump'
import api from '../api'

const RebootState = rj().effect({
  effectCaller: 'configured',
  effect: (t) => (id) => api.auth(t).post(`/api/or/dash/machines/${id}/reboot`),
})

export function useReboot() {
  return useRj(RebootState, [])
}
